<template>
  <div class="begin Center">
    <div class="beginBox">
      <img src="../assets/1/begin.png" class="wid100" alt="">
      <div class="btn">
        <img src="../assets/btn/begin.png" @click="handleClose" class="wid100" alt="">
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "begin",
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
  .begin{width: 100%; height: 100%; background: rgba(0,0,0,0.8); position: absolute; top:0; z-index: 11; overflow-y: auto; overflow-x: hidden}
  .begin .beginBox{width: 85%; position: relative}
  .begin .beginBox .btn{position: absolute; bottom: -15%; text-align: center;}
  .begin .beginBox .btn img{width: 60%; animation: scale1 1s infinite linear }
  @-webkit-keyframes scale1 {
    0%,100%{ transform: scale(1)}
    50%{ transform: scale(1.1)}
  }
</style>



// WEBPACK FOOTER //
// src/components/begin.vue